<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('loan applications')"
      :columns="columns"
      :column_search="true"
      resource_url="/loan/application/datatables"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="go_online_application"
        >
          <span class="icon"><i class="fa fa-globe"></i></span>
          <span>{{ $t("online application") }}</span>
        </button>
        <button
          class="button is-secondary is-rounded"
          @click="create_application"
        >
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <application-modal ref="application_modal" @success="refresh_datatable" />
    <application-detail-modal
      ref="application_detail_modal"
      @success="refresh_datatable"
      @reject-application="reject_application"
      @approve-application="approve_application"
    />
    <reject-modal ref="reject_modal" @success="refresh_datatable" />
    <approve-modal ref="approve_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
  format_date,
} from "@/utils";
import ApplicationModal from "./application_modal/Index.vue";
import ApplicationDetailModal from "./application_detail_modal/Index.vue";
import OnlineApplication from "../OnlineApplication.vue";
import RejectModal from "./reject_modal/Index.vue";
import ApproveModal from "./approve_modal/Index.vue";

export default {
  name: "ApplicationDataTable",
  components: {
    GenericTable,
    ApplicationModal,
    ApplicationDetailModal,
    RejectModal,
    ApproveModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        // {
        //   title: v.$t("application date"),
        //   searchable: true,
        //   data: (row) => {
        //     return format_date(row.create_date);
        //   },
        // },
        {
          title: v.$t("applicant name"),
          searchable: true,
          data: (row) => {
            return `<div class="title is-6">${row.applicant_first_name} ${
              row.applicant_last_name
            }</div>
            <div class="subtitle is-7 mb-0"><span class="icon"><i class="fa fa-envelope"></i></span> ${
              row.applicant_email || ""
            }</div>
            <div class="subtitle is-7"><span class="icon"><i class="fa fa-phone"></i></span> ${
              row.applicant_phone || ""
            }</div>`;
          },
        },
        {
          title: v.$t("requested amount"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">$${parseFloat(
              row.requested_amount
            ).toLocaleString()}</div>
            <div class="subtitle is-7">${
              row.loan_type ? row.loan_type.name : ""
            }</div>`;
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            let statusClass = "";
            switch (row.status) {
              case "pending":
                statusClass = "is-warning";
                break;
              case "under_review":
                statusClass = "is-info";
                break;
              case "approved":
                statusClass = "is-success";
                break;
              case "rejected":
                statusClass = "is-danger";
                break;
              case "cancelled":
                statusClass = "is-dark";
                break;
              default:
                statusClass = "is-dark";
            }
            let status_tag = `<span class="tag ${statusClass}">${v.$t(
              row.status
            )}</span>`;
            let create_date_tag = `<div class="subtitle is-7 mt-1"><span class="icon"><i class="fa fa-calendar"></i></span> ${format_date_time(
              row.create_date
            )}</div>`;
            return `<div class="has-text-centered">${status_tag}${create_date_tag}</div>`;
          },
        },
        {
          title: v.$t("actions"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.application_detail_modal.open(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("approve"),
                icon: "fa fa-check",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.approve_modal.open(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete application?"),
                    v,
                    () => {
                      del("/loan/application", { uuid: uuid })
                        .then(() => {
                          v.refresh_datatable();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create_application() {
      this.$refs.application_modal.show_modal();
    },
    edit_application(uuid) {
      this.$refs.application_modal.show_modal(uuid);
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
    go_online_application() {
      window.open("/loan/application/online", "_blank");
    },
    reject_application(uuid) {
      this.$refs.reject_modal.open(uuid);
    },
    approve_application(application) {
      this.$refs.approve_modal.open(application.uuid);
    },
  },
  mounted() {
    this.$refs.datatable.refresh();
  },
};
</script>
